import { useEffect, useState } from 'react'
import { api } from '../api/client'
import Aviso from '../components/Aviso'
import { competenciaAtual, moeda, pct } from '../components/format'

export default function ParametrosLegais() {
  const [competencia, setCompetencia] = useState(competenciaAtual())
  const [p, setP] = useState(null)
  const [erro, setErro] = useState('')

  useEffect(() => {
    setErro('')
    api.parametrosVigentes(competencia).then(setP).catch((e) => {
      setP(null)
      setErro(e.message)
    })
  }, [competencia])

  return (
    <section>
      <h2>Parâmetros legais globais</h2>
      <label className="inline">
        Competência <input type="month" value={competencia} onChange={(e) => setCompetencia(e.target.value)} />
      </label>
      <Aviso>{erro}</Aviso>
      {p && (
        <>
          <p className="fundamento">Versão {p.versao}, vigente desde {p.vigencia_inicio}. Salário mínimo {moeda(p.salario_minimo)}.</p>
          <div className="duas-colunas">
            <div>
              <h3>INSS (teto {moeda(p.inss.teto_contribuicao)})</h3>
              <table>
                <thead><tr><th>Até</th><th className="num">Alíquota</th></tr></thead>
                <tbody>
                  {p.inss.faixas.map((f) => (
                    <tr key={f.limite_superior}><td>{moeda(f.limite_superior)}</td><td className="num">{pct(f.aliquota, 1)}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div>
              <h3>IRRF</h3>
              <table>
                <thead><tr><th>Até</th><th className="num">Alíquota</th><th className="num">Dedução</th></tr></thead>
                <tbody>
                  {p.irrf.faixas.map((f, i) => (
                    <tr key={i}>
                      <td>{f.limite_superior ? moeda(f.limite_superior) : 'Acima'}</td>
                      <td className="num">{pct(f.aliquota, 1)}</td>
                      <td className="num">{moeda(f.parcela_deduzir)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p className="fundamento">
                Dependente {moeda(p.irrf.deducao_por_dependente)} · Desconto simplificado {moeda(p.irrf.desconto_simplificado)}
                {p.irrf.redutor?.ativo && ` · Redução até ${moeda(p.irrf.redutor.limite_reducao_parcial)}`}
              </p>
            </div>
          </div>
          <h3>Fontes</h3>
          <ul className="memoria">{p.fontes.map((f) => <li key={f}>{f}</li>)}</ul>
        </>
      )}
    </section>
  )
}
